import { Injectable } from '@angular/core';
import { AppUser } from '../security/model';
import { ConfigService } from '../config/config.service';
import { GoogleAnalyticsEvent } from './google-analytics-event';


@Injectable()
export class GaActivitiesService {
  private ga: (...any) => any;

  constructor(private config: ConfigService) {
    this.ga = (<any>window).ga;
  }

  pageView(url) {
    this.ga('set', 'page', url);
    this.ga('send', 'pageview');
  }

  create() {
    this.ga('create', this.config.appConfig.googleAnalyticsId, 'auto');
  }

  user(user: AppUser) {
    const userId = `${user.userId}`;
    this.ga('set', 'userId', userId);
  }

  event(event: GoogleAnalyticsEvent) {
    this.ga('send', 'event', {
      eventCategory: event.Category,
      eventLabel: event.Label,
      eventAction: event.Action,
      eventValue: 0
    });
  }
}



// WEBPACK FOOTER //
// /home/runner/work/cdg-missioncontrol/cdg-missioncontrol/MissionControlClient2/MissionControl.WebUi2/mc-app/src/app/core/google-analytics/ga-activities.service.ts